import React from "react";
import { useSelector } from "react-redux";
import DashboardLayout from "./DashboardLayout";
import CarrerLayout from "./CarrerLayout";

const RoleBasedLayout = ({ children }) => {
    const { user } = useSelector((state) => state.auth);

    const role = user?.role;

    if (role === "SHIPPER") {
        return (
            <CarrerLayout>
                {children}
            </CarrerLayout>
        );
    }

    return (
        <DashboardLayout>
            {children}
        </DashboardLayout>
    );
};

export default RoleBasedLayout;